<template>
  <div class="w-full h-full">
    <transition name="fade">
      <div
        v-if="show"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="show"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-50 backdrop-blur-sm"
      >
        <div class="relative w-full flex flex-col items-center justify-center">
          <div class="relative">
            <div
              class="absolute -top-4 -right-4 cursor-pointer rounded-full bg-white p-1.5 duration-500"
              @click="close()"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                  fill="#212121"
                />
              </svg>
            </div>
            <img
              v-click-away="close"
              :src="image"
              class="max-h-[80vh] max-w-[80vw]"
              alt=""
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ImageRating',
  props: {
    show: Boolean,
    image: String,
    close: Function,
  },
})
</script>
